import OriginTypography from './Typography';
import Text from './Text';
import Link from './Link';
import Title from './Title';
import Paragraph from './Paragraph';
const Typography = OriginTypography;
Typography.Text = Text;
Typography.Link = Link;
Typography.Title = Title;
Typography.Paragraph = Paragraph;
export default Typography;
